var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdverseMediaCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0876 14.4983L6.04468 14.4963C3.82153 14.4963 2.01904 12.6928 2.01904 10.4686V9.46525C2.01904 7.24108 3.82153 5.4386 6.04569 5.4386H13.0886L16.9853 2.77564C18.3219 1.86283 20.1344 2.81993 20.1344 4.43824V15.5007C20.1344 17.119 18.3209 18.0761 16.9853 17.1622L13.0876 14.4983Z",
    fill: "#3158F2",
    stroke: "white",
    strokeWidth: 1.63474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0894 5.6936V14.7513",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81264 13.6929H5.80518L6.6054 18.4932C6.72394 19.2064 7.3405 19.7289 8.0633 19.7289C8.97608 19.7289 9.67097 18.9094 9.52115 18.0079L8.82302 13.8169C8.81607 13.7752 8.81268 13.7338 8.81264 13.6929Z",
    fill: "#3158F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5662 17.7374C22.5662 14.9066 20.2719 12.6123 17.4415 12.6123C14.6106 12.6123 12.3164 14.9072 12.3164 17.7374C12.3164 20.5678 14.6113 22.8621 17.4415 22.8621C20.2719 22.8621 22.5662 20.5678 22.5662 17.7374Z",
    fill: "#3158F2",
    stroke: "white",
    strokeWidth: 1.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4419 17.8337V15.5913",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4413 19.5471C17.3793 19.5471 17.3291 19.5974 17.3296 19.6593C17.3296 19.7212 17.3798 19.7714 17.4417 19.7714C17.5036 19.7714 17.5538 19.7212 17.5538 19.6593C17.5538 19.5974 17.5036 19.5471 17.4413 19.5471Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdverseMediaCheck);
export default __webpack_public_path__ + "static/media/adverse_media_check.12280ee8c600de887a837b3137c8a4e7.svg";
export { ForwardRef as ReactComponent };